import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'error';

export interface StatusChipProps extends Omit<ChipProps, 'color' | 'variant'> {
  tone?: StatusTone;
}

const TONE_TO_COLOR: Record<StatusTone, ChipProps['color']> = {
  neutral: 'default',
  info: 'primary',
  success: 'success',
  warning: 'warning',
  error: 'error',
};

/**
 * The platform's one status chip.
 *
 * Modules pick a semantic tone rather than a colour, so "warning" looks the same in
 * APR as in SPN and stays correct if the palette changes.
 */
export function StatusChip({ tone = 'neutral', size = 'small', ...props }: StatusChipProps) {
  const color = TONE_TO_COLOR[tone];
  return (
    <Chip
      size={size}
      color={color}
      variant={tone === 'neutral' ? 'outlined' : 'filled'}
      {...props}
    />
  );
}
